import React from 'react';
import { useSelector } from 'react-redux';

const Careers = () => {
  const language = useSelector((state) => state.language);

  const jobs = [
    {
      en: { title: "Senior Backend Engineer", department: "Engineering", type: "Full-time" },
      fr: { title: "Ingénieur Backend Senior", department: "Ingénierie", type: "Temps plein" },
      ar: { title: "مهندس خلفية أول", department: "الهندسة", type: "بدوام كامل" }
    },
    {
      en: { title: "Product Designer", department: "Design", type: "Full-time" },
      fr: { title: "Designer Produit", department: "Conception", type: "Temps plein" },
      ar: { title: "مصمم منتج", department: "التصميم", type: "بدوام كامل" }
    },
    {
      en: { title: "Healthcare Consultant", department: "Sales", type: "Full-time" },
      fr: { title: "Consultant en Santé", department: "Ventes", type: "Temps plein" },
      ar: { title: "استشاري الرعاية الصحية", department: "المبيعات", type: "بدوام كامل" }
    },
  ];

  const getJobData = (job) => {
    if (language === "ar") return job.ar;
    if (language === "fr") return job.fr;
    return job.en;
  };

  return (
    <div className={`min-h-screen bg-gradient-to-br from-white via-blue-50 to-indigo-50 py-20 px-4`} dir={language === "ar" ? "rtl" : "ltr"}>
      <div className="container mx-auto max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          {language === "ar" ? "الوظائف" : language === "fr" ? "Carrières" : "Careers"}
        </h1>

        <div className="bg-white rounded-xl shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-teal-600 mb-4">
            {language === "ar" ? "انضم إلى فريقنا" : language === "fr" ? "Rejoignez notre équipe" : "Join Our Team"}
          </h2>
          <p className="text-gray-700 leading-relaxed mb-6">
            {language === "ar"
              ? "نحن نبحث عن أفراد موهوبين وشغوفين بتحسين الرعاية الصحية. إذا كنت تشاركنا الرؤية، فنحن نود أن نسمع منك!"
              : language === "fr"
              ? "Nous recherchons des personnes talentueuses passionnées par l'amélioration des soins de santé. Si vous partagez notre vision, nous aimerions vous entendre!"
              : "We're looking for talented individuals passionate about improving healthcare. If you share our vision, we'd love to hear from you!"}
          </p>

          <div className="space-y-4">
            {jobs.map((job, idx) => {
              const jobData = getJobData(job);
              return (
                <div key={idx} className="border border-gray-200 rounded-lg p-6 hover:shadow-md transition-shadow">
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-xl font-bold text-gray-900">{jobData.title}</h3>
                    <span className="bg-teal-100 text-teal-800 text-sm font-semibold px-3 py-1 rounded">
                      {jobData.type}
                    </span>
                  </div>
                  <p className="text-gray-600">{jobData.department}</p>
                </div>
              );
            })}
          </div>

          <button className="mt-8 w-full bg-teal-500 hover:bg-teal-600 text-white font-bold py-3 px-6 rounded-lg transition-colors">
            {language === "ar" ? "أرسل طلب التقديم" : language === "fr" ? "Postuler" : "Apply Now"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Careers;
